import { tagTextForAutomation } from "@/game/automation/automationTags";
import { HUD_HEIGHT, LAYOUT, TEXT_STYLES } from "@/game/constants";
import { navLog } from "@/game/debugNavigation";
import { EncounterScene } from "@/game/scenes/EncounterScene";
import { OVERWORLD_SCENE_KEY } from "@/game/scenes/OverworldScene";
import { BaseScreen } from "@/game/screens/BaseScreen";
import { newOverworldState } from "@/game/state/overworldState";
import { RunState, newRun } from "@/game/state/runState";
import { Button } from "@/game/ui/Button";
import type { ScreenContext } from "@/game/screens/types";

export class DefeatScreen extends BaseScreen {
  private run!: RunState;

  constructor(scene: EncounterScene) {
    super(scene, "DEFEAT");
  }

  enter(context?: ScreenContext) {
    this.run = context?.run ?? newRun();

    const { width, height } = this.scene.scale;

    // The persistent HUD banner already communicates "Defeat".
    // Keep this screen focused on next steps / summary.
    const contentTop = Math.max(LAYOUT.screenPadding, HUD_HEIGHT + 180);
    const title = this.scene.add
      .text(width / 2, contentTop, "Run Over", TEXT_STYLES.title)
      .setOrigin(0.5, 0);
    this.addToContainer(title);
    tagTextForAutomation(title, "defeat-title");

    const subtitle = this.scene.add
      .text(width / 2, contentTop + 56, `Reached floor ${this.run.floor}`, TEXT_STYLES.subtitle)
      .setOrigin(0.5, 0);
    this.addToContainer(subtitle);
    tagTextForAutomation(subtitle, "defeat-subtitle");

    const buttonWidth = width - LAYOUT.screenPadding * 2;

    const backButton = new Button(this.scene, LAYOUT.screenPadding, height * 0.7, {
      width: buttonWidth,
      height: LAYOUT.buttonHeight,
      label: "New Run",
      automationName: "back-to-start",
      onClick: () => {
        this.scene.overlay.hideBanner();
        this.startNewRun();
      },
    });
    this.addToContainer(backButton);
  }

  private startNewRun() {
    const run = newRun();
    const overworldState = newOverworldState(run);

    this.scene.overlay.transition(() => {
      navLog("DefeatScreen", "Starting overworld for new run.", { floor: run.floor });
      this.scene.scene.start(OVERWORLD_SCENE_KEY, {
        overworldState,
      });
    });
  }
}
